import React from "react";
import { useSelector } from "react-redux";

import styles from "./HallsPhoto.module.scss";
import {HallsPropsType} from "./types";
import {imagesSelector} from "../../../../redux/images/selectors";
import {useAppDispatch} from "../../../../redux/store";
import {fetchGetHallsGallery} from "../../../../redux/images/asyncActions";
import {MediaBreakPoints} from "../../../../resources/constants";
import Styles from "./OurClub/OurClub.module.scss";
import {useCurrentWidth} from "../../../../hooks";
import {Slider, Preloader} from "../../../../components";
import {useNavigate} from "react-router-dom";


export const HallsPhoto: React.FC<HallsPropsType> = ({ title }) => {
  const { hallsGallery, isLoading } = useSelector(imagesSelector);
  const dispatch = useAppDispatch();
  const windowWidth = useCurrentWidth();
  const breakPoint = MediaBreakPoints.MOBILE_LARGE;
  const navigation = useNavigate()

  React.useEffect(() => {
    dispatch(fetchGetHallsGallery());
  }, [dispatch]);

  const handleCardClick = (e: React.MouseEvent, hall: typeof hallsGallery[0]) => {
    const target = e.target as HTMLElement;
    if (target.closest('.swiper-button-prev') || target.closest('.swiper-button-next')) {
      return;
    }
    
    if (hall && hall.images && hall.images.length > 0) {
      sessionStorage.setItem("lastSelectedHall", JSON.stringify({
        title: hall.title,
        images: hall.images
      }));
      navigation("morePhoto");
    }
  };

  const renderHallsCards = () => {
    if (isLoading) {
      return <Preloader />;
    }

    if (!hallsGallery || hallsGallery.length === 0) {
      return <div>Нет доступных фотографий</div>;
    }

    return hallsGallery.map((hall) => {
      const { id, title, images } = hall;
      const photoLinks = images.map((photo) => photo.url);

      if (photoLinks.length === 0) {
        return null;
      }

      return (
          <div 
            key={id} 
            className={styles.card}
            onClick={(e) => handleCardClick(e, hall)}
          >
            <div className={styles.cardImage}>
              <Slider 
                images={photoLinks} 
                newStyle="slider_medium_img"
              />
            </div>
            <h3 className={styles.title}>{title}</h3>
          </div>
      );
    });
  };

  return (
      <div>
        <div className={styles.items}>
          {renderHallsCards()}
        </div>
      </div>
  );
};
